import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export function formatDate(value?: string | Date | null, pattern = 'DD MMM YYYY'): string {
  if (!value) return '—';
  const d = dayjs(value);
  return d.isValid() ? d.format(pattern) : '—';
}

export function formatRelative(value?: string | Date | null): string {
  if (!value) return '—';
  const d = dayjs(value);
  return d.isValid() ? d.fromNow() : '—';
}

export { dayjs };
